"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTooltip = void 0;
var breakpoints_1 = require("../../../theme/global/breakpoints");
var palette_1 = require("../../../theme/global/palette");
var shape_1 = require("../../../theme/global/shape");
var typography_1 = require("../../../theme/global/typography");
exports.MuiTooltip = {
    tooltip: __assign(__assign({}, typography_1.typography.caption), { backgroundColor: palette_1.palette.grey[800], borderRadius: shape_1.shape.borderRadius, padding: '6px 8px' }),
    tooltipPlacementBottom: (_a = {
            margin: 8
        },
        _a[breakpoints_1.breakpoints.up('sm')] = {
            margin: 8,
        },
        _a),
    tooltipPlacementTop: (_b = {
            margin: 8
        },
        _b[breakpoints_1.breakpoints.up('sm')] = {
            margin: 8,
        },
        _b),
    tooltipPlacementLeft: (_c = {
            margin: 8
        },
        _c[breakpoints_1.breakpoints.up('sm')] = {
            margin: 8,
        },
        _c),
    tooltipPlacementRight: (_d = {
            margin: 8
        },
        _d[breakpoints_1.breakpoints.up('sm')] = {
            margin: 8,
        },
        _d),
    arrow: { color: palette_1.palette.grey[800] },
};
